module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "exportdv"
  }, [_c('div', {}, [_c('el-button', {
    staticClass: "wh100",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSchool
    }
  }, [_vm._v("添加幼儿园")])], 1)]), _vm._v(" "), _c('optOpenClassDialog', {
    ref: "refoptOpenClassDialog"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30f0584d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/school/AddSchool/index.vue
// module id = 1438
// module chunks = 1